module.exports = __webpack_public_path__ + "static/media/w1.810054de.png";